import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	spotlightButtonLabel: {
		id: 'issue.views.common.child-issues-panel.heading.meatballs.whats-new',
		defaultMessage: "What's new?",
		description: 'An action link to trigger the spotlight tour for child issues table',
	},
});
